module.exports = __webpack_public_path__ + "main/assets/public/player/pause-icon.9cb1b40132832af1.svg";